import { Controller } from "@hotwired/stimulus"
import { trackingAllowed } from "../analytics"

// The analytics consent banner (shared/_analytics_consent.html.erb). Shown until the visitor
// chooses; a browser asking not to be tracked is never asked, and counts as no. Agreeing sets an
// anonymous id (kept a year) and a session id (renewed on each page, ending after 30 quiet
// minutes), which the server then attaches to this visitor's analytics events; declining sets
// neither and removes any already there. The choice itself is kept a year, and "Analytics
// preferences" in the footer asks again.
const YEAR = 60 * 60 * 24 * 365
const SESSION = 60 * 30

export default class extends Controller {
  connect() {
    const choice = this.cookie("fo_analytics")
    if (choice === "granted" && trackingAllowed()) {
      this.setCookie("fo_sid", this.cookie("fo_sid") || this.newId(), SESSION)
    }
    if (!choice && trackingAllowed()) this.element.hidden = false
  }

  accept() {
    this.setCookie("fo_analytics", "granted", YEAR)
    this.setCookie("fo_aid", this.cookie("fo_aid") || this.newId(), YEAR)
    this.setCookie("fo_sid", this.newId(), SESSION)
    this.element.hidden = true
  }

  decline() {
    this.setCookie("fo_analytics", "denied", YEAR)
    this.setCookie("fo_aid", "", 0)
    this.setCookie("fo_sid", "", 0)
    this.element.hidden = true
  }

  // The footer link: ask again.
  reopen(event) {
    event.preventDefault()
    this.element.hidden = false
  }

  cookie(name) {
    const match = document.cookie.split("; ").find((row) => row.startsWith(`${name}=`))
    return match ? decodeURIComponent(match.split("=")[1]) : null
  }

  setCookie(name, value, maxAge) {
    const secure = location.protocol === "https:" ? "; Secure" : ""
    document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; SameSite=Lax${secure}`
  }

  newId() {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID()
    return `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 14)}`
  }
}
